import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Button, Form as BootstrapForm, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Swal from 'sweetalert2';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useAuth } from '../../../../context/authContext';
import { useLoader } from '../../../../context/LoaderCotext';
import Cookies from 'js-cookie';
import moment from 'moment';
import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getFacilityBuildingRoomsList } from '../../../../services/FacilityBuildingRoomService';
import CreatableSelect from 'react-select/creatable';
import DatePicker from 'react-datepicker';

const OfferRequest = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [facilityList, setFacilityList] = useState([]);
  const [initialValues, setInitialValues] = useState({
    initiator: '',
    manager: '',
    candidateName: '',
    requisitionNumber: '',
    contractorLaborCategory: '',
    desiredStartDate: moment().toDate(),
    payRate: '',
    directSupervisor: '',
    newEmployeeSponsor: '',
    laborGroup: '',
    laborLocation: '',
    buildingRoom: '',
    interviewEval: '',
    referencesCompleted: '',
    relocationRequested: '',
    workVisaRequested: '',
    boxFolderId: '275393000439',
    boxFolderName: 'Offer-Forms',
    timestamp: moment().unix(),
  });

  const validationSchema = Yup.object().shape({
    initiator: Yup.string().required('Initiator name required'),
    manager: Yup.string().required('Manager name required'),
    candidateName: Yup.string().required('Required'),
    requisitionNumber: Yup.string().required('Required'),
    desiredStartDate: Yup.date().required('Required'),
    payRate: Yup.number().required('Required').typeError('Must be a number'),
    directSupervisor: Yup.string().required('Required'),
    newEmployeeSponsor: Yup.string().required('Required'),
    laborGroup: Yup.string().required('Required'),
    laborLocation: Yup.string().required('Required'),
    interviewEval: Yup.string().required('Required'),
    referencesCompleted: Yup.string().required('Required'),
    relocationRequested: Yup.string().required('Required'),
    workVisaRequested: Yup.string().required('Required'),
  });

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };
  useEffect(() => {
    setFolderAPISuccess(true);
  }, [cookieValue]);
  useEffect(() => {
    dispatch(employeeSearchAction(''));
    const getFacilityList = async () => {
      const fList = await getFacilityBuildingRoomsList();
      setFacilityList(fList || []);
    };
    getFacilityList();
  }, [dispatch]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
      setInitialValues((prev) => ({
        ...prev,
        initiator: profile.firstName + ' ' + profile.lastName,
      }));
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'offer-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    console.log('Form Submitted Data:', data);
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
      };
      handleUploadBatch(payloadForms);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Offer Request From" />
      <Card>
        {/* <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}
        >
          <Link className="mb-2 text-primary" target="_blank" style={{ marginLeft: '40px' }} to="#">
            Instruction to Submit Offer Request form
          </Link>
        </div> */}
        <h4 className="mb-4">Candidate Form</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ handleChange, setFieldValue, handleBlur, values }) => (
            <Form as={BootstrapForm}>
              <Row className="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="initiator">Form Initiator Name</label>
                    <Field
                      type="text"
                      name="initiator"
                      className="form-control"
                      placeholder="Form Initiator"
                      value={values.initiator}
                      readOnly
                    />
                    <ErrorMessage name="initiator" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="manager">Manager Name</label>
                    <AsyncSelect
                      name="manager"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Manager"
                      isSearchable
                      onChange={(selectedOption) => setFieldValue(`manager`, selectedOption.value)}
                    />
                    <ErrorMessage name="manager" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Candidate Name</BootstrapForm.Label>
                    <Field name="candidateName" className="form-control" />
                    <ErrorMessage name="candidateName" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Requisition Number</BootstrapForm.Label>
                    <Field name="requisitionNumber" className="form-control" />
                    <ErrorMessage
                      name="requisitionNumber"
                      component="div"
                      className="text-danger"
                    />
                  </BootstrapForm.Group>
                </Col>

                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Contract Labor Category</BootstrapForm.Label>
                    <Field name="contractorLaborCategory" className="form-control" />
                  </BootstrapForm.Group>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Desired Start Date</BootstrapForm.Label>

                    <DatePicker
                      name={`desiredStartDate`}
                      as={Form.Control}
                      selected={values.desiredStartDate}
                      onChange={async (date) => await setFieldValue(`desiredStartDate`, date)}
                      showYearDropdown
                      yearDropdownItemNumber={15}
                      scrollableYearDropdown
                      minDate={new Date()}
                      placeholderText="MM-DD-YYYY"
                      className="form-control"
                    />

                    <ErrorMessage name="desiredStartDate" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Pay Rate to Offer</BootstrapForm.Label>
                    <Field name="payRate" className="form-control" />
                    <ErrorMessage name="payRate" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Direct Supervisor</BootstrapForm.Label>
                    <AsyncSelect
                      name="manager"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Supervisor"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue(`directSupervisor`, selectedOption.value)
                      }
                    />
                    <ErrorMessage name="directSupervisor" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>

                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>New Employee Sponsor</BootstrapForm.Label>
                    <AsyncSelect
                      name="newEmployeeSponsor"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Employee Name"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue(`newEmployeeSponsor`, selectedOption.value)
                      }
                    />

                    <ErrorMessage
                      name="newEmployeeSponsor"
                      component="div"
                      className="text-danger"
                    />
                  </BootstrapForm.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Labor Group</BootstrapForm.Label>
                    <Select
                      name="laborGroup"
                      options={[
                        { label: 'FAC/IT Service Center', value: 'FAC/IT Service Center' },
                        { label: 'G&A PartTime', value: 'G&A PartTime' },
                        { label: 'G&A Regular', value: 'G&A Regular' },
                        { label: 'G&A Temp/Cas', value: 'G&A Temp/Cas' },
                        { label: 'Grant Projects Full Time', value: 'Grant Projects Full Time' },
                        { label: 'Grant Projects Part Time', value: 'Grant Projects Part Time' },
                        { label: 'Grant Projects Temp/Cas', value: 'Grant Projects Temp/Cas' },
                        { label: 'HR/PR Service Center', value: 'HR/PR Service Center' },
                        { label: 'Off-Site Full Time', value: 'Off-Site Full Time' },
                        { label: 'Off-Site Part Time', value: 'Off-Site Part Time' },
                        { label: 'Off-Site Temp/Cas', value: 'Off-Site Temp/Cas' },
                        { label: 'On-Site Full Time ', value: 'On-Site Full Time ' },
                        { label: 'On-Site Part Time', value: 'On-Site Part Time' },
                        { label: 'On-Site Temp/Cas', value: 'On-Site Temp/Cas' },
                        { label: 'Telecommuters Part Time', value: 'Telecommuters Part Time' },
                        { label: 'Telecommuters Regular', value: 'Telecommuters Regular' },
                        { label: 'Telecommuters Temp/Cas', value: 'Telecommuters Temp/Cas' },
                      ]}
                      onChange={(option) => {
                        setFieldValue('laborGroup', option.value);
                      }}
                    ></Select>
                    <ErrorMessage name="laborGroup" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Labor Location</BootstrapForm.Label>

                    <CreatableSelect
                      options={facilityList}
                      value={facilityList.find((e) => e.value === values.laborLocation)}
                      placeholder="Select or Create Location..."
                      onChange={(option) => setFieldValue(`laborLocation`, option.value)}
                      onCreateOption={(newValue) => {
                        // Optionally handle new value creation
                        const newOption = {
                          value: newValue,
                          label: newValue,
                        };
                        facilityList.push(newOption); // Add the new option to your facilityList array
                        setFieldValue(`laborLocation`, newOption.value); // Set the newly created value
                      }}
                    />
                    <ErrorMessage name="laborLocation" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Building/Room#</BootstrapForm.Label>
                    <Field name="buildingRoom" className="form-control" />
                  </BootstrapForm.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Interview Evaluation Complete?</BootstrapForm.Label>
                    <Select
                      name="interviewEval"
                      options={[
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                      ]}
                      onChange={(option) => {
                        setFieldValue('interviewEval', option.value);
                      }}
                    ></Select>
                    <ErrorMessage name="interviewEval" component="div" className="text-danger" />
                  </BootstrapForm.Group>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>References Completed?</BootstrapForm.Label>
                    <Select
                      name="referencesCompleted"
                      options={[
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                      ]}
                      onChange={(option) => {
                        setFieldValue('referencesCompleted', option.value);
                      }}
                    ></Select>
                    <ErrorMessage
                      name="referencesCompleted"
                      component="div"
                      className="text-danger"
                    />
                  </BootstrapForm.Group>
                </Col>

                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Relocation Requested?</BootstrapForm.Label>
                    <Select
                      name="relocationRequested"
                      options={[
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                      ]}
                      onChange={(option) => {
                        setFieldValue('relocationRequested', option.value);
                      }}
                    ></Select>
                    <ErrorMessage
                      name="relocationRequested"
                      component="div"
                      className="text-danger"
                    />
                  </BootstrapForm.Group>
                </Col>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Work Visa/Sponsorship Requested?</BootstrapForm.Label>
                    <Select
                      name="workVisaRequested"
                      options={[
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                      ]}
                      onChange={(option) => {
                        setFieldValue('workVisaRequested', option.value);
                      }}
                    ></Select>
                    <ErrorMessage
                      name="workVisaRequested"
                      component="div"
                      className="text-danger"
                    />
                  </BootstrapForm.Group>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button type="submit" variant="primary">
                  Submit
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(OfferRequest);
